import React from 'react';
import { Box, useTheme } from '@mui/material';

export const StatusDot = ({ active = true }) => {
  const theme = useTheme();

  const background = active
    ? `radial-gradient(circle at 30% 30%, #81c784, ${theme.palette.success.dark})`
    : `radial-gradient(circle at 30% 30%,rgb(201, 199, 199), ${theme.palette.grey[400]})`;

  return (
    <Box
      sx={{
        width: 20,
        height: 20,
        borderRadius: '50%',
        display: 'inline-block',
        background,
      }}
    />
  );
};

export default StatusDot;
